import { render } from "./ProcessPage.vue?vue&type=template&id=46f9660f&scoped=true"
import script from "./ProcessPage.vue?vue&type=script&lang=js"
export * from "./ProcessPage.vue?vue&type=script&lang=js"

import "./ProcessPage.vue?vue&type=style&index=0&id=46f9660f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f9660f"]])

export default __exports__